import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e5d5400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-card" }
const _hoisted_2 = { class: "notification-card__header" }
const _hoisted_3 = { class: "notification-card__title" }
const _hoisted_4 = { class: "notification-card__body" }
const _hoisted_5 = { class: "notification-card__text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseNotificationCard',
  props: {
    title: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.text ?? ''), 1),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})